import { LOGIN, LOGIN_SUCCESS, LOGIN_FAILED } from './../constants/constants';

import cookie from 'react-cookies';
const initialState = {
  loggedUser: {
    username: '',
    userType: '',
    isVerified: false,
  },

  success: {
    message: '',
  },
  error: {
    message: '',
  },
  loading: false,
};

const userLogin = (state = initialState, action) => {
  let msg = '';
  switch (action.type) {
    case LOGIN:
      return {
        ...state,
        loading: true,
      };
    case LOGIN_SUCCESS:
      if (cookie.load('username')) {
        msg = ``;
      }
      console.log(state);
      if (action.data.data[0].status == 0) {
        console.log('response', action.data.data[0].status);
        document.cookie = `username=${action.data.data[0].userId}; expires=; path=/`;
        document.cookie = `fullName=${action.data.data[0].Login_Id}; expires=; path=/`;
        return {
          ...state,
          loading: false,
          loggedUser: {
            isVerified: true,
            username: action.data.data[0].userId,
            fullName: action.data.data[0].userId,
            //userType: '2',
            userType: action.data.data[0].privelage,
          },
          success: {
            message: msg,
          },
        };
      } else {
        return {
          ...state,
          loading: false,
          loggedUser: {
            isVerified: false,
            username: '',
            userType: '',
          },
          error: {
            message: action.data.data.message,
          },
        };
      }
    case LOGIN_FAILED:
      if (cookie.load('username')) {
        msg = ``;
      }

      return {
        ...state,
        loading: false,
        loggedUser: {
          isVerified: false,
          username: '',
          userType: '',
        },
        error: {
          message: 'Invalid Username and password',
        },
      };
    default:
      return state;
  }
};
export default userLogin;
